import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';

import { Paging } from '../../../model/paging/paging';
import { Project } from '../../../model/project/project';

@Injectable({
  providedIn: 'root'
})
export class ProjectService_Mock {
  GETPaginatedProjects(paging: Paging, name?: string): Observable<Project> | any {
    const allData = this.getMockProjects();
    const term = name?.trim().toLowerCase() ?? '';
    const filteredData = !term
      ? allData
      : allData.filter((item) =>
          item.name.toLowerCase().includes(term) ||
          item.projectId.toLowerCase().includes(term) ||
          item.description.toLowerCase().includes(term)
        );
    const start = (paging.pageIndex - 1) * paging.pageSize;
    const end = start + paging.pageSize;
    const pageData = filteredData.slice(start, end);
    return of({
      success: true,
      errorCode: 0,
      errorMessage: null,
      elapsed: 11,
      data: {
        count: filteredData.length,
        items: pageData
      }
    });
  }

  GETProjectById(projectId: string): Observable<Project> | any {
    return of({
      success: true,
      errorCode: 0,
      errorMessage: null,
      elapsed: 8,
      data: this.getMockProjects().find((item) => item.projectId === projectId) ?? this.getMockProjects()[0]
    });
  }

  POSTProject(body: Project) {
    return of({
      success: true,
      errorCode: 0,
      errorMessage: null,
      elapsed: 9,
      data: 'proj-new123'
    });
  }

  PUTProject(projectId: string, body: Project) {
    return of({
      success: true,
      errorCode: 0,
      errorMessage: null,
      elapsed: 7,
      data: true
    });
  }

  DELETEProject(projectId: string) {
    return of({
      success: true,
      errorCode: 0,
      errorMessage: null,
      elapsed: 7,
      data: true
    });
  }

  private getMockProjects() {
    return [
      {
        projectId: 'proj-1a2b3c',
        name: 'Sede Logistica Milano',
        description: 'Simulazione copertura capannone principale',
        createdAt: '2026-04-17T10:00:00Z',
        updatedAt: '2026-04-17T10:30:00Z'
      },
      {
        projectId: 'proj-4d5e6f',
        name: 'Campus Torino',
        description: 'Analisi copertura edificio uffici e reception',
        createdAt: '2026-04-16T08:15:00Z',
        updatedAt: null
      },
      {
        projectId: 'proj-7g8h9i',
        name: 'Hub Bologna',
        description: 'Validazione progetto Wi-Fi area produzione',
        createdAt: '2026-04-15T14:20:00Z',
        updatedAt: '2026-04-18T09:05:00Z'
      }
    ];
  }
}
